import { API } from "config";
import type { Task } from "types/Task";
import request from "utilities/request";

const baseUrl = API.dbApi.url;

/**
 * Returns all of the caller's task rows (every chat), scoped by bearer token.
 * The response is a bare JSON array, mirroring the threads resource. The
 * backend's default GET keeps active dismissed rows (e.g. fetch trackers) and
 * excludes only terminal+dismissed history, so the poller still sees trackers
 * without passing `includeDismissed`.
 */
export async function getTasks(
  getAccessToken: () => Promise<string>
): Promise<Task[]> {
  const accessToken = await getAccessToken();

  const url = `${baseUrl}/tasks`;
  const headers = { Authorization: `Bearer ${accessToken}` };
  const options = { method: "GET", headers };

  const response = await request(url, options);
  return (await response.json()) as Task[];
}
